import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AppConstants } from 'src/app/common/app.constants';
import { MatDialog } from '@angular/material/dialog';
import { DepartmentComponent } from '../../department.component';
import { DepartmentModel } from '../../model/department.model';
@Component({
    selector: 'app-department-summary',
    templateUrl: './department-summary.component.html',
    styleUrls: ['./department-summary.component.scss'],
    standalone: false
})
export class DepartmentSummaryComponent {
  @Input() department: any;

  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();

  show: boolean = false;
  departments: any;

  constructor(
    private dialog: MatDialog
  ) {
    let sessionDepartment = sessionStorage.getItem(AppConstants.SESSION_VAR_DEPARTMENT);
    this.departments = (sessionDepartment !== null) ? JSON.parse(sessionDepartment) : [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['department']) {
    //   this.show = (this.department !== undefined);

    // }
  }

  /**
   * Closed the summary panel
   */
  close(): void {
    this.show = !this.show;
  }
  /**
   * Edit the current selected item
   */
  onEditAction() {
    this.onEdit.emit(this.department);
  }
  /**
   * Delete the current item.
   */
  onDeleteAction() {
    this.onDelete.emit(this.department);
  }

}
